import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

interface ChartProps {
  data: any[]
  xKey: string
  yKey: string
  color?: string
}

const Chart = ({ data, xKey, yKey, color = 'primary' }: ChartProps) => {
  const colorMap = {
    primary: '#3b82f6',
    success: '#22c55e',
    warning: '#f59e0b',
    danger: '#ef4444',
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xKey} />
        <YAxis />
        <Tooltip />
        <Line 
          type="monotone" 
          dataKey={yKey} 
          stroke={colorMap[color as keyof typeof colorMap]} 
          strokeWidth={2}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}

export default Chart 